<mat-form-field appearance="fill">
    <mat-label>Station</mat-label>
    <mat-select [(ngModel)]="selectedStation" (selectionChange)="updateStation(selectedStation)" [compareWith]="stationCompareFn">
        <mat-option *ngFor="let station of stations" [value]="{ id_station: station.id_station, name: station.name }">
            {{ station.name }}
        </mat-option>
    </mat-select>
</mat-form-field>